import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface QuickAddTaskProps {
  onSubmit: (title: string) => void
  onClose: () => void
}

/** Alta rápida desde la cabecera de columna: solo título (CLAUDE.md, fase 3). */
export function QuickAddTask({ onSubmit, onClose }: QuickAddTaskProps) {
  const { t } = useTranslation()
  const [title, setTitle] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <input
      ref={inputRef}
      type="text"
      value={title}
      onChange={(event) => setTitle(event.target.value)}
      onBlur={onClose}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
          const trimmed = title.trim()
          if (trimmed) {
            onSubmit(trimmed)
            setTitle('')
          }
        }
        if (event.key === 'Escape') {
          event.preventDefault()
          onClose()
        }
      }}
      placeholder={t('board.quickAdd.placeholder')}
      className="h-9 shrink-0 rounded-card bg-surface-hi px-3 text-body text-text outline-none placeholder:text-text-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
    />
  )
}
